import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const token = localStorage.getItem('authToken');
        if (token) {
            return true;
        } else if (token === '') {
            this.router.navigate(['/auth']);
            return false;
        } else {
            this.router.navigate(['/auth']);
            return false;
        }
    }
    // canActivate(): boolean {
    //     if (localStorage.getItem('authToken')) {
    //         this.router.navigate(['/pages']);
    //         return false;
    //     } else {
    //         return true;
    //     }
    // }
}


